import Vue from 'vue';
import router from './router.js';
import store from './store';
import i18n from './i18n';
import App from './App.vue';
import VueClipboard from 'vue-clipboard2';

import {
  MdField,
  MdList,
  MdMenu,
  MdButton,
  MdDialog,
} from 'vue-material/dist/components';

Vue.use(VueClipboard);

Vue.use(MdField);
Vue.use(MdList);
Vue.use(MdMenu);
Vue.use(MdButton);
Vue.use(MdDialog);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
